// extracted by mini-css-extract-plugin
module.exports = {"logo":"CompanyLogo_logo__2S5Rh"};